export const containsDuplicates = (list: number[]): boolean => {
  const listSet = new Set(list);
  const hasDuplicated = Array.from(listSet).length !== list.length;
  return hasDuplicated;
};

export const isDuplicated = (value: number, list: number[]): boolean => {
  const values = list.filter((item) => item === value);
  const isValueDuplciated = values.length > 1;
  return isValueDuplciated;
};
